export default {
  token: process.env.REACT_APP_ZENDESK_CHAT_TOKEN,
  stoneId: process.env.REACT_APP_ZENDESK_CHAT_STONE_ID,
  digitalId: process.env.REACT_APP_ZENDESK_CHAT_DIGITAL_ID,
  antecipacaoId: process.env.REACT_APP_ZENDESK_CHAT_ANTECIPACAO_ID,
  emprestimoId: process.env.REACT_APP_ZENDESK_CHAT_EMPRESTIMO_ID,
}
